<template>
  <div>
    <table
      class="unstriped hover boss-table"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center">
            表示用住所
          </th>
          <th class="boss-table-head-center boss-update">
            Googleマップ用住所
          </th>
          <th class="boss-table-head-center boss-update">
            プレビュー
          </th>
          <th class="boss-table-head-center boss-operation">
            編集
          </th>
          <th class="boss-table-head-center boss-operation">
            削除
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(place, i) in places"
          :key="i"
        >
          <td
            class="boss-table-data"
            data-test="place-name"
          >
            {{ place.placeName }}
          </td>
          <td
            class="boss-table-data"
            data-test="place-google-map"
          >
            {{ place.googleMapAddress | parseBlankForDefaultValue }}
          </td>
          <td
            class="boss-table-data"
            data-test="place-preview"
          >
            <button
              v-if="place.googleMapAddress"
              class="boss-button"
              :data-test="`place-preview-button-${i}`"
              @click="previewOpen (place.googleMapAddress)"
            >
              <span>Googleマップ</span>
            </button>
          </td>
          <td class="boss-table-data">
            <button
              class="boss-icon-pencil"
              data-test="place-edit"
              @click="callEditMordal(place)"
            />
          </td>
          <td
            class="boss-table-data"
            data-test="place-remove"
            @click="doRemove(place.placeId)"
          >
            <button class="boss-icon-trash" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  filters: {
    parseBlankForDefaultValue (label, suffix = '') {
      return label ? label + suffix : '未登録'
    }
  },
  props: {
    places: {
      type: Array,
      required: true
    }
  },
  methods: {
    removeInterviewPlaces (id) {
      return this.$http.secured.put(`/company/settings/entry/interview_place/${id}/_closed`)
    },
    doRemove (id) {
      this.$dialog.confirm('削除しますか？')
        // はいを押下した時
        .then(() => {
          this.removeInterviewPlaces(id) // 削除
            .then(() => {
              this.$toasted.global.success({ message: '面接場所を削除しました' })
              this.fetchPlaces()
            })
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    },
    previewOpen (googleMapAddress) {
      const openWidth = 900
      const openHeight = 550

      const screenX = window.screenX
      const screenY = window.screenY
      const centerX = window.outerWidth / 2
      const centerY = window.outerHeight / 2
      const displayX = screenX + centerX - (openWidth / 2)
      const displayY = screenY + centerY - (openHeight / 2)
      const url = `https://www.google.co.jp/maps?q=${googleMapAddress}`

      window.open(encodeURI(url), '_blank', `width=${openWidth}px, height=${openHeight}px,left=${displayX}px,top=${displayY}px,toolbar=yes, scrollbars=yes, menubar=yes, resizable=yes`)
    },
    callEditMordal (place) {
      this.$emit('editInterviewPlace', place) // モーダル内容の取得
    },
    fetchPlaces () {
      this.$emit('fetchPlaces') // 面接情報の再取得
    }
  }
}
</script>
